import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCsyRivLNPwFSHN8eA9S95IIC6XPvlXkjU",
  authDomain: "securbank-3aa53.firebaseapp.com",
  projectId: "securbank-3aa53",
  storageBucket: "securbank-3aa53.firebasestorage.app",
  messagingSenderId: "821080798137",
  appId: "1:821080798137:web:2a52fb08144e672a8dfc68"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

const secondaryApp = initializeApp(firebaseConfig, "secondary");
export const secondaryAuth = getAuth(secondaryApp);